<template>
    <div>
        <md-button class="md-icon-button md-list-action" @click.stop="deleteDialog.visible = true;">
            <md-tooltip md-direction="top">Click to delete asset</md-tooltip>
            <md-icon>delete</md-icon>
        </md-button>
        <md-dialog-confirm
            :md-active.sync="deleteDialog.visible"
            md-title="Delete this asset?"
            md-content="Are you sure you want to delete this asset?"
            md-confirm-text="Delete"
            md-cancel-text="Cancel"
            @md-cancel="deleteDialog.confirm = false"
            @md-confirm="deleteUploadedAsset()" />
        <md-snackbar
            :md-position="'center'"
            :md-active.sync="snackbarActive"
            :md-duration="10000"
            md-persistent
            >
            <span>{{ snackbarMessage }}</span>
        </md-snackbar>
    </div>
</template>
<script>
import { functions } from "@/firebaseFunctions.js";

export default {
    name: "DeleteAssetButton",
    props: {
        user: {
            type: Object
        },
        asset: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        deleteDialog: {
            visible: null,
            confirm: false,
        },
        snackbarActive: false,
        snackbarMessage: ""
    }),
    methods: {
        deleteUploadedAsset() {
            let data = {
                "org_id": this.user.orgId,
                "user_id": this.user.uid,
                "asset_id": this.asset.name,
            };
            functions.deleteUserAsset(data).then(response => {
                console.log(response);
                this.$emit('asset-deleted');
                // show snackbar
                this.snackbarMessage = "Asset successfully deleted";
                this.snackbarActive = true;
            }).catch(error => {
                console.error(error);
                // show snackbar
                this.snackbarMessage = "Asset could not be deleted. Try again later.";
                this.snackbarActive = true;
            });
        },
    }
}
</script>
